import React, { useState, useContext } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// Context
import useInventoryBalanceContext from '../context/useInventoryBalanceContext';

export default function Table() {
  const { loading, inventoryBalance, handleExportInventoryBalance } = useContext(
    useInventoryBalanceContext,
  );

  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'rep_name',
      headerName: 'MPR Name',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_group',
      headerName: 'Group',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'rep_team',
      headerName: 'Team',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_name',
      headerName: 'MD Name',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'product_name',
      headerName: 'Product Name',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'month_format',
      headerName: 'Month',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'beg_balance',
      headerName: 'Beginning Balance',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.beg_balance),
    },
    {
      field: 'allocation',
      headerName: 'Allocation',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.allocation),
    },
    {
      field: 'dispense',
      headerName: 'Distribution',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.dispense),
    },
    {
      field: 'balance',
      headerName: 'Remaining Balance',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.balance),
    },
  ];

  const pinnedRows = {
    top: inventoryBalance.length ? [inventoryBalance[0]] : [],
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid md={12}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant='contained'
              color='warning'
              onClick={handleExportInventoryBalance}
              startIcon={<CloudDownloadIcon />}
              sx={{
                marginLeft: '10px',
                paddingTop: '10px',
              }}
            >
              Export
            </Button>
          </Box>
        </Grid>
        <Grid md={12}>
          <Box
            className='table-container'
            sx={{
              height: '800px',
              marginLeft: '20px',
              '& .super-app-theme--header': {
                fontWeight: 'bold',
                backgroundColor: '#070738',
                color: '#fff',
              },
              '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#FBCEB1' },
            }}
          >
            <DataGridPro
              loading={loading}
              rows={inventoryBalance}
              columns={columns}
              sortModel={sortModel}
              pinnedRows={pinnedRows}
              experimentalFeatures={{ rowPinning: true }}
              initialState={{
                ...inventoryBalance.initialState,
                pagination: { paginationModel: { pageSize: 50 } },
                // pinnedColumns: { left: ['head_name', 'manager_name', 'rep_name'], right: [] },
              }}
              pageSizeOptions={[50, 75, 100]}
              pagination
              onSortModelChange={(model) => setSortModel(model)}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}
